export const disableBrowserBack = (param) => {
    return (function () {
        history.pushState(null, null, document.URL);
        if (window.history && window.history.pushState) {
            $(window).on('popstate', function () {
                window.history.pushState('forward', null, '');
                window.history.forward(1);
            });
        }
        window.history.pushState('forward', null, '');
        window.history.forward(1);
    })()
};



/**
 * @description 格式化表格单元格默认值(el-table-column)
 * @param {Number} row 行
 * @param {Number} col 列
 * @param {String} callValue 当前单元格值
 * @return string
 * */
export function formatDateTime(dateTime,format) {
    const date = new Date(dateTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return format.replace('YYYY', `${year}`).replace('MM', `${month}`).
        replace('DD', `${day}`).replace('hh', `${hours}`).replace('mm', `${minutes}`)
        .replace('ss', `${seconds}`)
    // return `${year}-${month}-${day}-${hours}:${minutes}:${seconds}`;
}
  
/**
 * @description 将时间戳转化为时间date
 * @param {String} timeStamp 传入的时间戳
 * @return string
 * */
export function formatDate(time, fmt) {
	if (time === undefined || "") {
		return;
	}
	if (typeof time === "number" && time.toString().length === 10) {
		time = time * 1000;
	}
	const date = new Date(time);
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	const o = {
		"M+": date.getMonth() + 1,
		"d+": date.getDate(),
		"h+": date.getHours(),
		"m+": date.getMinutes(),
		"s+": date.getSeconds()
	};
	for (const k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			const str = o[k] + "";
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
		}
	}
	return fmt;
}

//下载文件
export function downloadFile(fileUrl, fileName) {
	if (!fileUrl || !fileName) {
		return;
	}
	const a = document.createElement("a");
	a.href = fileUrl;
	a.download = fileName;
	a.style.display = "none";
	document.body.appendChild(a);
	a.click();
	URL.revokeObjectURL(a.href);
	document.body.removeChild(a);
}